"use client"
import React, { useState, useEffect, useCallback } from "react"
// import Carousel from "nuka-carousel"
import { Carousel } from "nuka-carousel"
import * as classes from "./technologies.module.scss"
import { useBreakpoint } from "../../../../hooks/breakpoints"
import { cn } from "@/utils/cn"
import useEmblaCarousel from 'embla-carousel-react';
const Technologies = ({ data, theme }) => {
	const [canPrev, setCanPrev] = useState(false);
	const [canNext, setCanNext] = useState(false);
	const [emblaRef, emblaApi] = useEmblaCarousel({
		axis: 'x',

		dragFree: true,
		slidesToScroll: 'auto',
		skipSnaps: true,
		// containScroll: 'keepSnaps',
		containScroll: 'trimSnaps',
	});

	const onSelect = useCallback(() => {
		if (!emblaApi) return;
		setCanPrev(emblaApi.canScrollPrev());
		setCanNext(emblaApi.canScrollNext());
	}, [emblaApi]);


	useEffect(() => {
		if (!emblaApi) return;
		onSelect();                     // инициализация
		emblaApi.on('select', onSelect);
		emblaApi.on('reInit', onSelect);
	}, [emblaApi, onSelect]);

	const showArrows = canPrev || canNext

	const leftButton = () => {
		return (
			<button
				onClick={() => emblaApi?.scrollPrev()}
				disabled={!canPrev}
				className=" disabled:opacity-40 cursor-pointer disabled:cursor-default"
				// className="border  border-green-500 disabled:opacity-40 cursor-pointer disabled:cursor-default"
				// className="border flex justify-center items-center size-10 border-green-500 disabled:opacity-40 cursor-pointer disabled:cursor-default"
				style={{
					// border: "none",
					// background: "transparent",
					cursor: "pointer",
				}}
			>
				<img
					src="/icons/arrow_down_icon.svg"
					alt="arrow"
					className="object-cover"
					style={{
						transform: "rotate(90deg)",
					}}
				/>
			</button>
		)
	}
	const rightButton = () => {
		return (
			<button
				onClick={() => emblaApi?.scrollNext()}
				disabled={!canNext}
				className=" disabled:opacity-40 cursor-pointer disabled:cursor-default"
				// className="border  border-green-500 disabled:opacity-40 cursor-pointer disabled:cursor-default"
				// className="border flex justify-center items-center size-10 border-green-500 disabled:opacity-40 cursor-pointer disabled:cursor-default"
				style={{
					// border: "none",
					// background: "transparent",
					cursor: "pointer",
				}}
			>
				<img
					src="/icons/arrow_down_icon.svg"
					alt="arrow"
					className="object-cover"
					style={{
						transform: "rotate(-90deg)",
					}}
				/>
			</button>
		)
	}
	return (
		<>
			<div
				className={classes["technologiesWrapper"]}
				style={{
					fontFamily: theme.fontFamilyPrimary,
				}}
			>
				<div
					className={classes["title"]}
					style={{
						borderBottomColor: theme.lineColor,
						color: theme.primaryTextColor,
						marginBottom: "20px",

					}}
				>
					TECHNOLOGIES
				</div>
				<div className="flex items-center  max-w-full mx-auto w-full mb-10 md:mb-0">
					<div className="size-[30px] flex justify-start items-center">{showArrows && leftButton()}</div>

					<div
						className="max-w-[calc(100%_-_60px)]  overflow-hidden cursor-grab  mx-auto "
						// className="max-w-[calc(100%_-_60px)] overflow-hidden cursor-grab  mx-auto border border-red-500"
						ref={emblaRef}
					>
						{/* <div className="max-w-[90%] overflow-hidden cursor-grab xl:max-w-fit mx-auto" ref={emblaRef}> */}
						<div className="flex gap-4 ">
							{data.slice().map((item, index) => (
							//{data.slice(0, 3).map((item, index) => (
								<div
									key={index}
									className="flex select-none items-center justify-center mr-6 last:mr-0"
									style={{ flex: '0 0 auto' }}
								>
									<img
										src={item || '/icons/person.svg'}
										alt="technology"
										className="h-[80px] object-contain"
									// className="h-[45px] md:h-[52px] xl:h-[80px] object-contain"
									/>
								</div>
							))}
						</div>
					</div>
					<div className="size-[30px] flex justify-end items-center">{showArrows && rightButton()}</div>

				</div>

			</div>
		</>
	)
}
// const Technologies = ({ data, theme }) => {
// 	const [canPrev, setCanPrev] = useState(false);
// 	const [canNext, setCanNext] = useState(false);
// 	const [emblaRef, emblaApi] = useEmblaCarousel({
// 		axis: 'x',

// 		dragFree: true,
// 		slidesToScroll: 'auto',
// 		skipSnaps: true,
// 		// containScroll: 'keepSnaps',
// 		containScroll: 'trimSnaps',
// 	});
// 	const breakpoint = useBreakpoint()
// 	const [slideToShow, setSlideToShow] = useState(
// 		data.length > 5 ? 5 : data.length
// 	)

// 	useEffect(() => {
// 		breakpoint.sm || breakpoint.xs
// 			? setSlideToShow(1)
// 			: breakpoint.md
// 				? setSlideToShow(2)
// 				: breakpoint.l
// 					? setSlideToShow(data.length > 4 ? 4 : data.length)
// 					: setSlideToShow(data.length > 4 ? 4 : data.length)
// 	}, [breakpoint, slideToShow]) // eslint-disable-line react-hooks/exhaustive-deps
// 	const onSelect = useCallback(() => {
// 		if (!emblaApi) return;
// 		setCanPrev(emblaApi.canScrollPrev());
// 		setCanNext(emblaApi.canScrollNext());
// 	}, [emblaApi]);

// 	useEffect(() => {
// 		if (!emblaApi) return;
// 		onSelect();                     // инициализация
// 		emblaApi.on('select', onSelect);
// 		emblaApi.on('reInit', onSelect);
// 	}, [emblaApi, onSelect]);
// 	const showArrows = canPrev || canNext
// 	const leftButton = () => {
// 		return (
// 			<button
// 				onClick={() => emblaApi?.scrollPrev()}
// 				disabled={!canPrev}
// 				className="absolute xl:left-0 xl:top-10 top-5 left-[-8px]   disabled:opacity-40 cursor-pointer disabled:cursor-default"
// 				style={{
// 					border: "none",
// 					background: "transparent",
// 					cursor: "pointer",
// 				}}
// 			>
// 				<img
// 					src="/icons/arrow_down_icon.svg"
// 					alt="arrow"
// 					style={{
// 						transform: "rotate(90deg) translateY(50px)",
// 						margin: 0,
// 						padding: 0,
// 					}}
// 				/>
// 			</button>
// 		)
// 	}
// 	const rightButton = () => {
// 		return (
// 			<button
// 				onClick={() => emblaApi?.scrollNext()}
// 				disabled={!canNext}
// 				className="absolute xl:right-0 xl:top-10  right-[-8px] top-5 disabled:opacity-40 cursor-pointer disabled:cursor-default"
// 				style={{
// 					border: "none",
// 					background: "transparent",
// 					cursor: "pointer",
// 				}}
// 			>
// 				<img
// 					src="/icons/arrow_down_icon.svg"
// 					alt="arrow"
// 					style={{
// 						transform: "rotate(-90deg) translateY(50px)",
// 						margin: 0,
// 						padding: 0,
// 					}}
// 				/>
// 			</button>
// 		)
// 	}
// 	const leftButton2 = () => {
// 		return (
// 			<button
// 				onClick={() => emblaApi?.scrollPrev()}
// 				disabled={!canPrev}
// 				className=" disabled:opacity-40 cursor-pointer disabled:cursor-default"
// 				style={{
// 					border: "none",
// 					background: "transparent",
// 					cursor: "pointer",
// 				}}
// 			>
// 				<img
// 					src="/icons/arrow_down_icon.svg"
// 					alt="arrow"
// 					style={{
// 						transform: "rotate(90deg) translateY(50px)",
// 						margin: 0,
// 						padding: 0,
// 					}}
// 				/>
// 			</button>
// 		)
// 	}
// 	const rightButton2 = () => {
// 		return (
// 			<button
// 				onClick={() => emblaApi?.scrollNext()}
// 				disabled={!canNext}
// 				className="disabled:opacity-40 cursor-pointer disabled:cursor-default"
// 				style={{
// 					border: "none",
// 					background: "transparent",
// 					cursor: "pointer",
// 				}}
// 			>
// 				<img
// 					src="/icons/arrow_down_icon.svg"
// 					alt="arrow"
// 					style={{
// 						transform: "rotate(-90deg) translateY(50px)",
// 						margin: 0,
// 						padding: 0,
// 					}}
// 				/>
// 			</button>
// 		)
// 	}
// 	return (
// 		<>
// 			<div
// 				className={classes["technologiesWrapper"]}
// 				style={{
// 					fontFamily: theme.fontFamilyPrimary,
// 				}}
// 			>
// 				<div
// 					className={classes["title"]}
// 					style={{
// 						borderBottomColor: theme.lineColor,
// 						color: theme.primaryTextColor,
// 						marginBottom: "20px",

// 					}}
// 				>
// 					TECHNOLOGIES
// 				</div>
// 				<div className="flex items-center  max-w-full mx-auto w-full">
// 					{/* <div className="flex items-center justify-center max-w-[1200px] mx-auto border border-blue-500"> */}
// 					{showArrows ? (
// 						<button
// 							onClick={() => emblaApi?.scrollPrev()}
// 							disabled={!canPrev}
// 							className=" disabled:opacity-40 cursor-pointer disabled:cursor-default"
// 							// className="border  border-green-500 disabled:opacity-40 cursor-pointer disabled:cursor-default"
// 							// className="border flex justify-center items-center size-10 border-green-500 disabled:opacity-40 cursor-pointer disabled:cursor-default"
// 							style={{
// 								// border: "none",
// 								// background: "transparent",
// 								cursor: "pointer",
// 							}}
// 						>
// 							<img
// 								src="/icons/arrow_down_icon.svg"
// 								alt="arrow"
// 								className="object-cover"
// 								style={{
// 									transform: "rotate(90deg)",
// 								}}
// 							/>
// 						</button>) : <div className="size-[30px]" />}
// 					{/* {showArrows && leftButton2()} */}
// 					<div
// 						className="max-w-[calc(100%_-_60px)]  overflow-hidden cursor-grab  mx-auto "
// 						// className="max-w-[calc(100%_-_60px)] overflow-hidden cursor-grab  mx-auto border border-red-500"
// 						ref={emblaRef}
// 					>
// 						{/* <div className="max-w-[90%] overflow-hidden cursor-grab xl:max-w-fit mx-auto" ref={emblaRef}> */}
// 						<div className="flex gap-4 ">
// 							{data.slice().map((item, index) => (
// 								//{data.slice(0, 3).map((item, index) => (
// 								<div
// 									key={index}
// 									className="flex select-none items-center justify-center mr-6 last:mr-0"
// 									style={{ flex: '0 0 auto' }}
// 								>
// 									<img
// 										src={item || '/icons/person.svg'}
// 										alt="technology"
// 										className="h-[80px] object-contain"
// 										// className="h-[45px] md:h-[52px] xl:h-[80px] object-contain"
// 									/>
// 								</div>
// 							))}
// 						</div>
// 					</div>
// 					{showArrows ? (<button
// 						onClick={() => emblaApi?.scrollNext()}
// 						disabled={!canNext}
// 						className=" disabled:opacity-40 cursor-pointer disabled:cursor-default"
// 						// className="border  border-green-500 disabled:opacity-40 cursor-pointer disabled:cursor-default"
// 						// className="border flex justify-center items-center size-10 border-green-500 disabled:opacity-40 cursor-pointer disabled:cursor-default"
// 						style={{
// 							// border: "none",
// 							// background: "transparent",
// 							cursor: "pointer",
// 						}}
// 					>
// 						<img
// 							src="/icons/arrow_down_icon.svg"
// 							alt="arrow"
// 							className="object-cover"
// 							style={{
// 								transform: "rotate(-90deg)",
// 							}}
// 						/>
// 					</button>) : <div className="size-[30px]"></div>}
// 				</div>
// 				{/* <div className="relative">
// 					{showArrows && leftButton()}
// 					<div className="max-w-[90%] overflow-hidden cursor-grab xl:max-w-fit mx-auto mt-4" ref={emblaRef}>
// 						<div className="flex gap-4 ">
// 							{data.slice().map((item, index) => (
// 								// {data.slice(0, 3).map((item, index) => (
// 								<div
// 									key={index}
// 									className="flex select-none items-center justify-center mr-6 last:mr-0"
// 									style={{ flex: '0 0 auto' }}
// 								>
// 									<img
// 										src={item || '/icons/person.svg'}
// 										alt="technology"
// 										className="h-[45px] md:h-[52px] xl:h-[80px] object-contain"
// 									/>
// 								</div>
// 							))}
// 						</div>
// 					</div>
// 					{showArrows && rightButton()}
// 				</div> */}

// 				{/* <div className={classes["sliderWrapper"]}>
// 					<Carousel
// 						slidesToShow={slideToShow}
// 						renderBottomCenterControls={() => false}
// 						width="100%"
// 						framePadding="0px 10px "
// 						renderCenterLeftControls={({ previousSlide }) =>
// 							slideToShow < data.length && (
// 								<button
// 									onClick={previousSlide}
// 									style={{
// 										border: "none",
// 										background: "transparent",
// 										cursor: "pointer",
// 									}}
// 								>
// 									<img
// 										src="/icons/arrow_down_icon.svg"
// 										alt="arrow"
// 										style={{
// 											transform: "rotate(90deg) translateY(50px)",
// 											margin: 0,
// 											padding: 0,
// 										}}
// 									/>
// 								</button>
// 							)
// 						}
// 						renderCenterRightControls={({ nextSlide }) =>
// 							slideToShow < data.length && (
// 								<button
// 									onClick={nextSlide}
// 									style={{
// 										border: "none",
// 										background: "transparent",
// 										cursor: "pointer",
// 									}}
// 								>
// 									<img
// 										src="/icons/arrow_down_icon.svg"
// 										alt="arrow"
// 										style={{
// 											transform: "rotate(-90deg) translateY(50px)",
// 											margin: 0,
// 											padding: 0,
// 										}}
// 									/>
// 								</button>
// 							)
// 						}
// 					>
// 						{data.map((i, index) => {
// 							return (
// 								<div key={index} className={classes["slide"]}>
// 									<img src={i} alt="logo" />
// 								</div>
// 							)
// 						})}
// 					</Carousel>
// 				</div> */}
// 			</div>
// 		</>
// 	)
// }
// const Technologies = ({ data, theme }) => {

// 	const [emblaRef, emblaApi] = useEmblaCarousel({
// 		axis: 'x',

// 		dragFree: true,
// 		slidesToScroll: 2,
// 		skipSnaps: true,
// 		// containScroll: 'keepSnaps',
// 		containScroll: 'trimSnaps',
// 	});
// 	const breakpoint = useBreakpoint()
// 	const [slideToShow, setSlideToShow] = useState(
// 		data.length > 5 ? 5 : data.length
// 	)

// 	useEffect(() => {
// 		breakpoint.sm || breakpoint.xs
// 			? setSlideToShow(1)
// 			: breakpoint.md
// 				? setSlideToShow(2)
// 				: breakpoint.l
// 					? setSlideToShow(data.length > 4 ? 4 : data.length)
// 					: setSlideToShow(data.length > 4 ? 4 : data.length)
// 	}, [breakpoint, slideToShow]) // eslint-disable-line react-hooks/exhaustive-deps

// 	return (
// 		<>
// 			<div
// 				className={classes["technologiesWrapper"]}
// 				style={{
// 					fontFamily: theme.fontFamilyPrimary,
// 				}}
// 			>
// 				<div
// 					className={classes["title"]}
// 					style={{
// 						borderBottomColor: theme.lineColor,
// 						color: theme.primaryTextColor,
// 					}}
// 				>
// 					TECHNOLOGIES
// 				</div>

// 				<div className={classes["sliderWrapper"]}>
// 					<Carousel
// 						slidesToShow={slideToShow}
// 						renderBottomCenterControls={() => false}
// 						width="100%"
// 						framePadding="0px 10px "
// 						renderCenterLeftControls={({ previousSlide }) =>
// 							slideToShow < data.length && (
// 								<button
// 									onClick={previousSlide}
// 									style={{
// 										border: "none",
// 										background: "transparent",
// 										cursor: "pointer",
// 									}}
// 								>
// 									<img
// 										src="/icons/arrow_down_icon.svg"
// 										alt="arrow"
// 										style={{
// 											transform: "rotate(90deg) translateY(50px)",
// 											margin: 0,
// 											padding: 0,
// 										}}
// 									/>
// 								</button>
// 							)
// 						}
// 						renderCenterRightControls={({ nextSlide }) =>
// 							slideToShow < data.length && (
// 								<button
// 									onClick={nextSlide}
// 									style={{
// 										border: "none",
// 										background: "transparent",
// 										cursor: "pointer",
// 									}}
// 								>
// 									<img
// 										src="/icons/arrow_down_icon.svg"
// 										alt="arrow"
// 										style={{
// 											transform: "rotate(-90deg) translateY(50px)",
// 											margin: 0,
// 											padding: 0,
// 										}}
// 									/>
// 								</button>
// 							)
// 						}
// 					>
// 						{data.map((i, index) => {
// 							return (
// 								<div key={index} className={classes["slide"]}>
// 									<img src={i} alt="logo" />
// 								</div>
// 							)
// 						})}
// 					</Carousel>
// 				</div>
// 			</div>
// 		</>
// 	)
// }

export default Technologies
